function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  fill: "currentColor",
  height: "1em",
  width: "1em",
  viewBox: "64 64 896 896"
}, props), React.createElement("path", {
  d: "M840.8 64.5a51.45 51.45 0 0171.575 0l47.8 46.7c19.75 19.3 19.75 50.55.075 69.875L635.5 500l324.75 318.925a48.675 48.675 0 01-.075 69.875l-47.8 46.7a51.45 51.45 0 01-71.575 0L431 535a48.675 48.675 0 010-69.95zm-391.175 0a51.45 51.45 0 0171.575 0l47.8 46.7c19.75 19.3 19.75 50.55.075 69.875L244.325 500l324.75 318.925A48.675 48.675 0 01569 888.8l-47.8 46.7a51.45 51.45 0 01-71.575 0L39.825 535a48.675 48.675 0 010-69.95z"
})));